export default "__VITE_ASSET__5REYWr67__"